import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function MarkerIcon({ icon }) {
  return <FontAwesomeIcon
    icon={['fas', icon ? icon : 'location-dot']} />;
}
